import React, { lazy, Suspense, useState} from 'react';

import {BrowserRouter as Router, Route,Routes} from 'react-router-dom'
import { Nav } from './components'
import { loader } from './assets/images';

const LandingPage=lazy(()=>import('./pages/landing page/LandingPage'))
const AboutMe=lazy(()=>import('./pages/about me/AboutMe'))

function App() {
const [loader,setLoader]=useState(true)
setTimeout(()=>{
  setLoader(false)
},3000)
  return (
    <div className="overflow-x-hidden">

      <Suspense fallback={<div className='fixed overflow-hidden w-full h-full top-0 flex bg-black'>
<svg className="m-auto w-full" width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle className="animate-circle" cx="40" cy="39.8" r="20" fill="#A6B2EC"/>
<path className='half-circle' d="M74.4605 40C77.5199 40 80.0394 37.5081 79.6171 34.478C78.6961 27.8709 76.1323 21.5678 72.1221 16.1636C67.0062 9.26944 59.808 4.20411 51.5914 1.71632C43.3747 -0.771473 34.5757 -0.549713 26.4949 2.34882C18.414 5.24735 11.4801 10.6689 6.71799 17.812C1.9559 24.9551 -0.381674 33.4409 0.0507822 42.0149C0.483239 50.589 3.66277 58.7965 9.11944 65.4242C14.5761 72.0519 22.0203 76.7482 30.3518 78.819C36.8827 80.4422 43.687 80.3845 50.1401 78.6934C53.0996 77.9179 54.4307 74.6337 53.254 71.8097C52.0773 68.9856 48.8341 67.7082 45.8377 68.3257C41.6236 69.1941 37.2449 69.1161 33.0242 68.067C27.0003 66.5698 21.6179 63.1743 17.6726 58.3823C13.7273 53.5903 11.4285 47.6561 11.1158 41.4569C10.8031 35.2576 12.4932 29.1222 15.9363 23.9576C19.3794 18.7929 24.3928 14.873 30.2355 12.7773C36.0781 10.6816 42.44 10.5213 48.3808 12.32C54.3216 14.1187 59.5261 17.7811 63.225 22.7657C65.8167 26.2583 67.5729 30.2702 68.392 34.4941C68.9745 37.4976 71.4011 40 74.4605 40Z" fill="#F2C94C"/>
</svg>
</div>}>

{loader?(<div className='fixed overflow-hidden w-full h-full top-0 flex bg-black'>
<svg className="m-auto w-full" width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle className="animate-circle" cx="40" cy="39.8" r="20" fill="#A6B2EC"/>
<path className='half-circle' d="M74.4605 40C77.5199 40 80.0394 37.5081 79.6171 34.478C78.6961 27.8709 76.1323 21.5678 72.1221 16.1636C67.0062 9.26944 59.808 4.20411 51.5914 1.71632C43.3747 -0.771473 34.5757 -0.549713 26.4949 2.34882C18.414 5.24735 11.4801 10.6689 6.71799 17.812C1.9559 24.9551 -0.381674 33.4409 0.0507822 42.0149C0.483239 50.589 3.66277 58.7965 9.11944 65.4242C14.5761 72.0519 22.0203 76.7482 30.3518 78.819C36.8827 80.4422 43.687 80.3845 50.1401 78.6934C53.0996 77.9179 54.4307 74.6337 53.254 71.8097C52.0773 68.9856 48.8341 67.7082 45.8377 68.3257C41.6236 69.1941 37.2449 69.1161 33.0242 68.067C27.0003 66.5698 21.6179 63.1743 17.6726 58.3823C13.7273 53.5903 11.4285 47.6561 11.1158 41.4569C10.8031 35.2576 12.4932 29.1222 15.9363 23.9576C19.3794 18.7929 24.3928 14.873 30.2355 12.7773C36.0781 10.6816 42.44 10.5213 48.3808 12.32C54.3216 14.1187 59.5261 17.7811 63.225 22.7657C65.8167 26.2583 67.5729 30.2702 68.392 34.4941C68.9745 37.4976 71.4011 40 74.4605 40Z" fill="#F2C94C"/>
</svg>
</div>):( <Router>
      <Nav />

        <Routes>
          <Route path='/' element={ <LandingPage/>}/>
          <Route path='/about' element={ <AboutMe/>}/>
        
        </Routes>
        </Router>)}
       

        
      
      </Suspense>
    </div>
  );
}

export default App;
